import { render, staticRenderFns } from "./Info_List.vue?vue&type=template&id=4a39997a&"
import script from "./Info_List.vue?vue&type=script&lang=js&"
export * from "./Info_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports